import { render, staticRenderFns } from "./ProgressPagination.vue?vue&type=template&id=46c321c9&"
import script from "./ProgressPagination.vue?vue&type=script&lang=js&"
export * from "./ProgressPagination.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports